function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import './modal.scss';
import ChooseOneFlavorTile from './chooseOneFlavorTile';
import ChooseQuantityFlavorTile from './chooseQuantityFlavorTile';
import ModalCloseButton from './modalCloseButton';
import QuantityExceededModal from './quantityExceededModal';
import 'js-loading-overlay';
export default function FlavorSelectorModal(_ref) {
  var isOpen = _ref.isOpen,
      onRequestClose = _ref.onRequestClose,
      onAddToCart = _ref.onAddToCart,
      sellingPlanId = _ref.sellingPlanId,
      _ref$quantity = _ref.quantity,
      quantity = _ref$quantity === void 0 ? 1 : _ref$quantity,
      product = _ref.product,
      _ref$isBusy = _ref.isBusy,
      isBusy = _ref$isBusy === void 0 ? false : _ref$isBusy;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      selectedQuantities = _useState2[0],
      setSelectedQuantities = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isQuantityExceededModalOpen = _useState4[0],
      setIsQtyExceededModalOpen = _useState4[1]; // filter out discontinued variants


  var variants = product.variants.filter(function (variant) {
    return variant && variant.title && !variant.title.startsWith('Discontinued');
  });
  var totalSelected = Object.values(selectedQuantities).reduce(function (sum, val) {
    return sum + val;
  }, 0);
  useEffect(function () {
    if (isBusy) {
      var _window$JsLoadingOver;

      // eslint-disable-next-line no-unused-expressions
      (_window$JsLoadingOver = window.JsLoadingOverlay) === null || _window$JsLoadingOver === void 0 ? void 0 : _window$JsLoadingOver.show({
        spinnerIcon: 'ball-pulse',
        spinnerColor: '#2BB34D',
        spinnerZIndex: 10000012,
        overlayZIndex: 10000011
      });
    } else {
      var _window$JsLoadingOver2;

      // eslint-disable-next-line no-unused-expressions
      (_window$JsLoadingOver2 = window.JsLoadingOverlay) === null || _window$JsLoadingOver2 === void 0 ? void 0 : _window$JsLoadingOver2.hide();
    }
  }, [isBusy]);

  function handleSingleSelection(productVariant) {
    onAddToCart([{
      quantity: 1,
      variant: productVariant,
      sellingPlanId: sellingPlanId
    }]);
  }

  function handleMixAndMatchAddToCart() {
    var cartItems = [];
    Object.keys(selectedQuantities).forEach(function (variantId) {
      var variant = variants.find(function (vnt) {
        return vnt.id === parseInt(variantId, 10);
      });
      var qty = selectedQuantities[variantId];

      if (variant && qty > 0) {
        cartItems.push({
          variant: variant,
          quantity: qty,
          sellingPlanId: sellingPlanId
        });
      }
    });

    if (cartItems.length) {
      onAddToCart(cartItems);
    }
  }

  function handleQuantityChange(productVariant, selectedQuantity) {
    var newSelectedQuantities = _objectSpread(_objectSpread({}, selectedQuantities), {}, _defineProperty({}, productVariant.id, selectedQuantity));

    var newTotalSelected = Object.values(newSelectedQuantities).reduce(function (sum, val) {
      return sum + val;
    }, 0);

    if (newTotalSelected <= quantity) {
      setSelectedQuantities(newSelectedQuantities);
    } else {
      setIsQtyExceededModalOpen(true);
    }
  }

  function handleRequestClose() {
    // clear selected quantities
    setSelectedQuantities({});
    handleCloseQuantityExceededModal();
    onRequestClose();
  }

  function handleCloseQuantityExceededModal() {
    setIsQtyExceededModalOpen(false);
  }

  var title = quantity === 1 ? 'Select a Flavor' : 'Select Flavor Quantities';
  var subtitle = quantity === 1 ? "Choose from ".concat(variants.length, " Flavors") : "Mix and Match Up To ".concat(Math.min(quantity, variants.length), " Flavors");
  var addToCartText = sellingPlanId ? 'Subscribe & Save' : 'Add To Cart';
  var addToCartButtonText = totalSelected >= quantity ? addToCartText : 'Choose Flavors';
  var addToCartBar =
  /*#__PURE__*/

  /* eslint-disable quotes */
  React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__bottomBar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__mbg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__mbgDays"
  }, /*#__PURE__*/React.createElement("p", null, "60-Day")), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__mbgGuarantee"
  }, /*#__PURE__*/React.createElement("p", null, "Money-Back"), /*#__PURE__*/React.createElement("p", null, "Guarantee"))), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__addToCart"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    disabled: totalSelected < quantity,
    onClick: handleMixAndMatchAddToCart
  }, addToCartButtonText)), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__quantitySelected"
  }, /*#__PURE__*/React.createElement("p", null, totalSelected, " / ", quantity), /*#__PURE__*/React.createElement("p", null, "Selected"))))
  /* eslint-enable quotes */
  ;
  /* eslint-disable quotes */

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onRequestClose: handleRequestClose,
    contentLabel: "Choose Your Flavor",
    className: "btFlavorSelector btFlavorSelector__modal",
    overlayClassName: "btFlavorSelector btFlavorSelector__overlay"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__modalWrapper"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__header"
  }, /*#__PURE__*/React.createElement("h1", null, title), /*#__PURE__*/React.createElement("h3", null, subtitle)), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__arrowDown"
  }), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__body"
  }, variants.map(function (variant) {
    return quantity === 1 ? /*#__PURE__*/React.createElement(ChooseOneFlavorTile, {
      key: variant.id,
      productVariant: variant,
      onSelected: handleSingleSelection
    }) : /*#__PURE__*/React.createElement(ChooseQuantityFlavorTile, {
      key: variant.id,
      productVariant: variant,
      quantity: selectedQuantities[variant.id] || 0,
      onQuantityChange: handleQuantityChange
    });
  }))), quantity > 1 && addToCartBar, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__mbg--mobile"
  }, /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__mbgDays btFlavorSelector__mbgDays--mobile"
  }, /*#__PURE__*/React.createElement("p", null, "60-Day")), /*#__PURE__*/React.createElement("div", {
    className: "btFlavorSelector__mbgGuarantee btFlavorSelector__mbgGuarantee--mobile"
  }, /*#__PURE__*/React.createElement("p", null, "Money-Back"), /*#__PURE__*/React.createElement("p", null, "Guarantee"))), /*#__PURE__*/React.createElement(ModalCloseButton, {
    onClick: handleRequestClose
  })), /*#__PURE__*/React.createElement(QuantityExceededModal, {
    isOpen: isQuantityExceededModalOpen,
    onRequestClose: handleCloseQuantityExceededModal
  }));
}
FlavorSelectorModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onAddToCart: PropTypes.func.isRequired,
  product: PropTypes.object.isRequired,
  sellingPlanId: PropTypes.number,
  quantity: PropTypes.number,
  isBusy: PropTypes.bool
};